<template>
    <ContentComp>
        <AlertMessage
            v-if="false"
            type="info"
            class="mb-3"
        >
            <div v-html="$tm('stationrole.trackinginfo', '', true)"></div>
        </AlertMessage>

        <FormLayout
            v-if="model != null"
            :label-width="250"
        >
            <FormLayoutRow>
                <FormLayoutLabel text="stationrole.showasstartcontrol"></FormLayoutLabel>
                <InputBool v-model="model!.StartControl" />
            </FormLayoutRow>
            <FormLayoutRow>
                <FormLayoutLabel text="stationrole.startcontrolminimumtime"></FormLayoutLabel>
                <div class="w-25">
                    <InputNullableInt
                        v-model="model!.StartControlMin"
                        icon=""
                        :posttext="$tm('gpioreadings.groupsecond')"
                    />
                </div>
            </FormLayoutRow>
            <FormLayoutRow>
                <FormLayoutLabel text="stationrole.startcontrolmaximumtime"></FormLayoutLabel>
                <div class="w-25">
                    <InputNullableInt
                        v-model="model!.StartControlMax"
                        icon=""
                        :posttext="$tm('gpioreadings.groupsecond')"
                    />
                </div>
            </FormLayoutRow>
        </FormLayout>
    </ContentComp>
</template>
<script lang="ts" setup>
import { AlertMessage, InputBool, InputNullableInt } from '@/components';

import { FormLayout, FormLayoutLabel, FormLayoutRow } from '@/components/Form';
import ContentComp from '@/components/layout/ContentComp.vue';
import { StationRole } from '@/objects/generated';

const model = defineModel<StationRole | null>({ required: true });
</script>
